import type {
  Alert,
  AlertDelivery,
  AlertDeliveryRow,
  AlertType,
} from "@/types/api";
import { request } from "./transport";

export interface AlertInput {
  position_id?: string | null;
  type?: AlertType;
  condition?: Record<string, unknown>;
  delivery?: AlertDelivery;
  active?: boolean;
}

export const alerts = {
  listAlerts: (params?: {
    type?: AlertType;
    active?: boolean;
    triggered?: boolean;
  }) => {
    const qs = new URLSearchParams();
    if (params?.type) qs.set("type", params.type);
    if (params?.active !== undefined) qs.set("active", String(params.active));
    if (params?.triggered !== undefined)
      qs.set("triggered", String(params.triggered));
    const q = qs.toString();
    return request<{ alerts: Alert[] }>(`/alerts${q ? `?${q}` : ""}`);
  },

  createAlert: (input: AlertInput) =>
    request<{ alert: Alert }>("/alerts", {
      method: "POST",
      body: JSON.stringify({ alert: input }),
    }),

  updateAlert: (id: string, patch: AlertInput) =>
    request<{ alert: Alert }>(`/alerts/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ alert: patch }),
    }),

  deleteAlert: (id: string) =>
    request<{ ok: true }>(`/alerts/${id}`, { method: "DELETE" }),

  reorderAlerts: (alertIds: string[]) =>
    request<{ alerts: Alert[] }>("/alerts/reorder", {
      method: "PATCH",
      body: JSON.stringify({ alert_ids: alertIds }),
    }),

  listAlertDeliveries: (params?: { alert_id?: string; since?: string }) => {
    const qs = new URLSearchParams();
    if (params?.alert_id) qs.set("alert_id", params.alert_id);
    if (params?.since) qs.set("since", params.since);
    const q = qs.toString();
    return request<{ alert_deliveries: AlertDeliveryRow[] }>(
      `/alert_deliveries${q ? `?${q}` : ""}`,
    );
  },
};
